import { Lightning, Log, Registry, Router, VideoPlayer } from '@lightningjs/sdk'
import { api } from '../lib/api/Api'
import { Socket } from '../lib/api/socket'
import { appSettings } from '../lib/AppSettings'
import NowPlayingAsset from '../lib/assets/brand/NowPlayingAsset'
import PlayerHelper from '../lib/PlayerHelpers'

export default class GlobalPlayer extends Lightning.Component {
  static _template() {
    return {
      alpha: 0.001,
    }
  }

  _init() {
    this._playerMode = {
      linear: true,
      loop: false,
      shuffle: false,
    }

    this._playerHelper = new PlayerHelper(this)
    this._playerHelper.initPlayer()
  }
  _active() {
    VideoPlayer.consumer(this)
  }
  onPlayerUpdate({ state, list, listType, startIndex, type, item = null }) {
    this._playlist = list ? list : this._playlist
    this._listDataType = listType
    this._itemType = type
    this._playingItem = item

    this._startIndex = startIndex || 0
    this._currentTrackIndex = startIndex || 0

    this.playlistID = this._playlist ? this._playlist.id : null

    switch (state) {
      case 'startplay':
        this._playlist = list
        this._listDataType = type
        this._startIndex = startIndex
        this._previousTrackIndex = this._currentTrackIndex
        this._currentTrackIndex = this._startIndex

        this._startPlay(type)
        break
      case 'startIndex':
        this._startIndex = startIndex
        this._previousTrackIndex = this._currentTrackIndex
        this._currentTrackIndex = this._startIndex

        this._startPlay(type)
        break
      case 'pause':
        this.pause()
        break
      case 'play':
        this.play()
        break
      case 'stop':
        this.stop()
        break
      case 'next':
        // this.playNextTrack();
        break
      case 'prev':
        // this.playPreviousTrack();
        break
      case 'error':
        Log.error('PlayerError :', state)
        break
    }
  }

  openWebSocket(stationID, timestamp, isOpenRadio) {
    return new Promise(resolve => {
      const socketInstance = new Socket(
        api.domains.webSocket,
        stationID,
        () => {},
        err => {
          if (err !== undefined) {
            Log.warn('socket err  : ', err)
          }
        }
      )

      socketInstance.connect()

      if (isOpenRadio) {
        this.socket = socketInstance
      } else {
        this.socketB = socketInstance
      }

      if (isOpenRadio) {
        this.clientSocket = socketInstance.clientSocket
      } else {
        this.clientSocketB = socketInstance.clientSocket
      }

      if (this.clientSocket) {
        this.clientSocket.addEventListener('message', mesg => {
          const data = JSON.parse(mesg.data)

          appSettings.nowPlaying = new NowPlayingAsset(data)
          appSettings.nowPlaying.currentShow.station = appSettings.currentBrand.nationalStation
          appSettings.nowPlaying.currentShow.brandName = appSettings.currentBrand.brandName
          let _activePage = Router.getActivePage()
          if (_activePage.radioMessage) {
            _activePage.radioMessage()
          }
          Log.info('RADIO MESSAGE', data)
          resolve(timestamp)
        })
      }

      if (this.clientSocketB) {
        this.clientSocketB.addEventListener('message', mesg => {
          const data = JSON.parse(mesg.data)

          appSettings.nowPlaying = new NowPlayingAsset(data)
          appSettings.nowPlaying.currentShow.station = appSettings.currentBrand.nationalStation
          appSettings.nowPlaying.currentShow.brandName = appSettings.currentBrand.brandName
          Log.info('NOW PLAYING MESSAGE ', data)

          let _activePage = Router.getActivePage()
          if (_activePage.widgets && _activePage.widgets.sidemenu) {
            _activePage.widgets.sidemenu.radioMessageNowPlaying()
          }
          resolve(timestamp)
        })
      }
    })
  }

  // Control functions ------------------------------------------------------------------
  closeWebSocket(both) {
    if (this.socket) {
      this.socket.close()
      this.socket = undefined
    }
    if (this.socketB && both) {
      this.socketB.close()
      this.socketB = undefined
    }
  }
  openRadio(radioID, timestamp) {
    return new Promise(resolve => {
      if (
        this.socket &&
        this.socket.clientSocket &&
        this.socket.clientSocket.readyState !== WebSocket.CLOSED
      ) {
        this.socket.open(radioID)
        resolve(timestamp)
      } else {
        Log.info('OPEN SOCKET')
        this.openWebSocket(radioID, timestamp, true).then(() => {
          resolve(timestamp)
        })
      }
    })
  }

  openNowPlaying(radioID, timestamp) {
    return new Promise(resolve => {
      if (
        this.socketB &&
        this.socketB.clientSocket &&
        this.socketB.clientSocket.readyState !== WebSocket.CLOSED
      ) {
        this.socketB.open(radioID)
        resolve(timestamp)
      } else {
        this.openWebSocket(radioID, timestamp, false).then(() => {
          resolve(timestamp)
        })
      }
    })
  }

  _playStation() {
    if (VideoPlayer.playing) {
      VideoPlayer.close()
    }
    VideoPlayer.open(appSettings.currentStation.streamUrl)
  }

  _startPlay() {
    this._currentTrack = this._playlist[this._currentTrackIndex]

    this._updateNowPlaying()

    this._play()
  }

  _play() {
    if (VideoPlayer.playing) {
      VideoPlayer.close()
    }
    VideoPlayer.open(this._currentTrack.url)
  }

  play() {
    if (VideoPlayer.playing) {
      VideoPlayer.close()
    }
    this._updateNowPlaying()

    VideoPlayer.play()
  }

  pause() {
    this._updateNowPlaying()
    VideoPlayer.pause()
  }

  playPause() {
    VideoPlayer.playPause()
  }

  stop() {
    VideoPlayer.close()
  }

  _updateNowPlaying() {
    if (this._playingItem) {
      appSettings.nowPlaying = {}
      appSettings.nowPlaying.currentPlaying = this._playingItem
      appSettings.nowPlaying.currentPlaying.type = this._itemType
      appSettings.nowPlaying.currentShow = {
        station: appSettings.currentBrand.nationalStation,
      }
    }
  }

  //Setters -----------------------------------------------------------------------------

  set skip(sec) {
    VideoPlayer.skip(sec)
  }

  // Getters ----------------------------------------------------------------------------

  get playerMode() {
    return this._playerMode
  }

  get playbuttonState() {
    return this._playbuttonState
  }

  get isSocket() {
    return this.socket
  }

  get isConnected() {
    if (this.socket) {
      return this.socket.isConnected
    } else {
      return false
    }
  }

  get currentPlaying() {
    return this._playingItem

    // return appSettings.currentStation.streamUrl
  }

  // player states and emitter ----------------------------------------------------------
  $videoPlayerEvent(event) {
    let fireEvent = false
    switch (event) {
      case 'LoadStart':
        this._playbuttonState = 'playing'
        fireEvent = true
        break
      case 'LoadedData':
        this._playbuttonState = 'playing'
        fireEvent = true
        break
      case 'Play':
        this._playbuttonState = 'playing'
        fireEvent = true
        VideoPlayer.play()
        break
      case 'Pause':
        this._playbuttonState = 'pause'
        fireEvent = true
        break
      case 'Playing':
        this._playbuttonState = 'playing'
        fireEvent = true
        // this.fireAncestors("$liveVideoPlayerEvent", event);
        break
      case 'Seeked':
        VideoPlayer.play()
        break
      case 'Waiting':
        fireEvent = false
        break
      case 'Seeking':
        fireEvent = true
        Registry.setTimeout(() => {
          VideoPlayer.play()
        }, 100)
        break
      case 'Ended':
        this._playbuttonState = 'ended'

        fireEvent = true
        break
      case 'Clear':
        this._playbuttonState = 'stop'

        fireEvent = true
        break
      case 'TimeUpdate':
        fireEvent = false
        break
      case 'Error':
        fireEvent = false
        Log.error('VideoPlayerError')
        if (Router.getActivePage() && Router.getActivePage().playbackError) {
          Router.getActivePage().playbackError()
        }
        break
    }

    if (fireEvent === true) {
      let _activePage = Router.getActivePage()
      if (_activePage.widgets && _activePage.widgets.sidemenu) {
        _activePage.widgets.sidemenu.OnGpStateChange({
          state: event,
          playbuttonState: this._playbuttonState,
        })
      }
      if (_activePage.OnGpStateChange) {
        _activePage.OnGpStateChange({ state: event, playbuttonState: this._playbuttonState })
      }
    }
  }
}
